const localHistory = {
  history: [],

  init: browserHistory => {
    browserHistory.listen((location, action) => {
      if (action === 'PUSH') localHistory.history.push(location)
      if (action === 'POP') localHistory.history.pop()
      if (action === 'REPLACE') {
        localHistory.history[localHistory.history.length - 1] = location
      }
    })
  },

  previousLocation: (units = 1) =>
    localHistory.history[localHistory.history.length - units] || {}
}

export default localHistory



// WEBPACK FOOTER //
// ./src/modules/localHistory/index.js